<template>
  <article>
   <div class="filter mt-20 mb-20">
      <div class="filter__item">
        <el-select class="filter__input" size="mini" v-model="filters.fcid" filterable placeholder="请选择">
          <el-option :label="item.category" :value="item.fcid" v-for="(item, index) in featureCategoryLists" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item">
        <div class="filter__name">属性：</div>
        <el-input v-model="filters.attribute" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="ml-auto">
        <button class="blue-small-btn mr-10" @click="getList">搜索</button>
        <button class="blue-small-btn" @click="detailDialog = !detailDialog">新建</button>
      </div>
    </div>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="700">
      <el-table-column prop="faid" label="属性ID" width="" align="center" sortable>
      </el-table-column>
      <el-table-column prop="fcid" label="特征ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="category" label="特征" width="" align="center" sortable>
      </el-table-column>
      <el-table-column prop="attribute" label="属性" width="" align="center" sortable>
      </el-table-column>
      <el-table-column prop="weight" label="权重" width="" align="center">
      </el-table-column>
      <el-table-column label="操作" width="180" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="flex jcc">
            <button class="blue-small-btn" @click="editDetail(scope.$index)">编辑</button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100, 200]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
    <el-dialog title="分类编辑" :visible.sync="detailDialog" size="tiny" width="800px" center>
      <div class="flex fdr aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">属性ID</div>
            <el-input v-model="detail.faid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">特征名</div>
            <el-select placeholder="请选择" v-model="detail.fcid" :disabled="detail.faid != 0">
              <el-option v-for="item in featureCategoryLists" :key="item.fcid" :label="item.category" class="dataForm__input"  :value="item.fcid"> </el-option>
            </el-select>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">权重</div>
            <el-input v-model="detail.weight" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">属性</div>
            <el-input v-model="detail.attribute" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
        </div>
      </div>
      <div class="flex fdc aic">
        <div class="flex mt-30">
          <div class="blue-large-btn mr-20" @click="shopFeatureAttributeEdit">保存</div>
          <div class="gray-large-btn" @click="detailDialog = false">取消</div>
        </div>
      </div>
    </el-dialog>
  </article>
</template>
<script>
import util from '../../../script/util'
import {shopFeatureCategoryLists, shopFeatureAttributeLists, shopFeatureAttributeEdit} from '../../../api/api'
import uploadHeadImage from '../../../components/uploadImage.vue'
export default {
  name: 'shopFeatureAttribute',
  components: {
    uploadHeadImage
  },
  data () {
    return {
      filters: {
        p: 1,
        l: 20,
        total: 0,
        fcid: '',
        attribute: ''
      },
      lists: [],
      featureCategoryLists: [],
      listLoading: false,
      detailDialog: false,
      detail: {
        faid: 0,
        fcid: '',
        attribute: '',
        weight: 0
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    editDetail (index) {
      this.detailDialog = true
      for (let key in this.detail) {
        this.detail[key] = this.lists[index][key]
      }
    },
    shopFeatureAttributeEdit () {
      let params = {
        faid: this.detail.faid,
        fcid: this.detail.fcid,
        weight: this.detail.weight,
        attribute: this.detail.attribute
      }

      let content = ''

      if (params['fcid'] === '') {
        content = '请选择特征'
      }

      if (params['attributes'] === '') {
        content = '请填写属性'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      shopFeatureAttributeEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.detailDialog = false
          this.getList()

          for (let key in this.detail) {
            this.detail[key] = ''
          }
          this.detail.faid = 0
          this.detail.weight = 0
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }

      if (filters.fcid !== '') {
        params.fcid = filters.fcid
      }

      if (filters.attribute !== '') {
        params.attribute = filters.attribute
      }

      this.listLoading = true
      shopFeatureAttributeLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    },
    getFeatureCategoryLists () {
      let params = {
      }

      this.listLoading = true
      shopFeatureCategoryLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.featureCategoryLists = data.d.lists.map((item, index) => {
            return {
              category: item.category + '(' + item.fcid + ')',
              fcid: item.fcid
            }
          })
          this.featureCategoryLists.unshift({
            category: '所有',
            fcid: ''
          })
        }
      })
    }
  },
  mounted () {
    this.getFeatureCategoryLists()
    this.getList()
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
    'filters.fcid': 'getList',
    'filters.attribute': 'getList'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/shop/shopFeatureAttribute.vue